import { render, staticRenderFns } from "./PayFor.vue?vue&type=template&id=795a7a5e&"
import script from "./PayFor.vue?vue&type=script&lang=js&"
export * from "./PayFor.vue?vue&type=script&lang=js&"
import style0 from "./PayFor.vue?vue&type=style&index=0&id=795a7a5e&prod&lang=less&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports